import dateHelper from '../helpers/dateHelper'

export default {
  methods: {
    formatShortDateString (jsonDateString) {
      if (!jsonDateString) return ''
      var dt = dateHelper.createDateFromJSON(jsonDateString)
      return dateHelper.getShortDateString(dt)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/date.js